import React from "react";
import { Grid, Box } from "@material-ui/core";
import TreeItemNode from "components/TreeView/TreeItemNode";

const AccessRestrictionCreate = ({
  columns,
  selectedCodes,
  setSelectedCodes,
  parentMap,
  styleClass,
}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          gap={2}
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: 3,
            border: "1px solid #e0e0e0",
          }}
          p={3}
          m={2}
          className={styleClass}
        >
          {columns.map((column, idx) => (
            <Box key={idx} flex={1}>
              {column.map((node) => (
                <TreeItemNode
                  key={node.key}
                  node={node}
                  selectedCodes={selectedCodes}
                  setSelectedCodes={setSelectedCodes}
                  parentMap={parentMap}
                />
              ))}
            </Box>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default AccessRestrictionCreate;
